interface PaginationParams {
  readonly currentPage: number;
  readonly totalPages: number;
}

const getNextPage = (pagination: PaginationParams): number | null => {
  const hasMorePages = pagination.currentPage < pagination.totalPages;

  return hasMorePages ? pagination.currentPage + 1 : null;
};

const mergePaginatedResult = <TQuery extends Record<string, unknown>, TKey extends keyof TQuery>(
  previous: TQuery | undefined | null,
  incoming: TQuery | undefined | null,
  key: TKey,
): TQuery => {
  if (!previous) {
    return incoming as TQuery;
  }

  if (!incoming) {
    return previous as TQuery;
  }

  const previousEntity = previous[key];
  const incomingEntity = incoming[key];

  const previousData =
    previousEntity &&
    typeof previousEntity === 'object' &&
    'data' in previousEntity &&
    Array.isArray((previousEntity as any).data)
      ? (previousEntity as any).data
      : [];

  const incomingData =
    incomingEntity &&
    typeof incomingEntity === 'object' &&
    'data' in incomingEntity &&
    Array.isArray((incomingEntity as any).data)
      ? (incomingEntity as any).data
      : [];

  return {
    ...previous,
    ...incoming,
    [key]: {
      ...(typeof previousEntity === 'object' ? previousEntity : {}),
      ...(typeof incomingEntity === 'object' ? incomingEntity : {}),
      data: [...previousData, ...incomingData],
    },
  };
};

export { getNextPage, mergePaginatedResult };
